import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Namespace } from 'enums-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Identity } from 'storage-service-lib';
import { environment } from '../../../environments/environment';
import { VerifyLoginOtpResponse } from '../../components/login/login.service';
import { AbstractAuthService } from './abstract.auth.service';

@Injectable({ providedIn: 'root' })
export class InveniasAuthService extends AbstractAuthService {
  constructor(private http: HttpClient) {
    super();
  }

  override signIn(tenantName: string, options?: { env?: string }): Observable<any> {
    const callbackUrl = this.getRedirectUri();
    const requestAuthenticationHostUrl = `${environment.kpHost}/auth/invenias/host?tenantName=${tenantName}&targetCallback=${callbackUrl}`;
    return this.http.get(requestAuthenticationHostUrl, { responseType: 'text' }).pipe(
      map((authHostUrl) => {
        let launchUrl = `${environment.uiHost}/launchLogin.html`;
        launchUrl += '?redirectUrl=' + encodeURIComponent(authHostUrl);

        const buildIdentity = (jwt: string) => ({
          namespace: Namespace.invenias,
          tenant: tenantName,
          token: jwt,
        });
        const successCallback = () => {
          localStorage.setItem('lastUsedTenant', tenantName);
        };

        return { launchUrl, buildIdentity, successCallback };
      })
    );
  }

  override signInWithOtp(decodedToken: any, otpObject: VerifyLoginOtpResponse, loginSuccess: EventEmitter<Identity>): void {
    const tenantNameDomain = decodedToken['http://www.invenias.com/claims/EndpointUrl'];
    const tenantName = tenantNameDomain.split('.')[0];
    localStorage.setItem('lastUsedTenant', tenantName);
    loginSuccess.emit({
      namespace: Namespace.invenias,
      tenant: tenantName,
      token: otpObject.jwtToken,
    });
  }
}
